<template>
    <div
        class="avatar"
        :class="shape === 'circle' ? 'shape-circle' : ''"
    >
        <img :src="avatarSrc">
    </div>
</template>

<script>
// import systemAvatar from '@/assets/image/system.png'
import { mapGetters } from 'vuex'
import person from '@/assets/img/person.png'
import actor from '@/assets/img/actor.png'
export default {
    ...mapGetters([ 'locale', 'ident', 'mainLoading' ]),
    props: {
        src: String,
        type: {
            type: String,
            default: 'C2C'
        },
        shape: {
            type: String,
            default: 'circle'
        }
    },
    return: {
        person,
        actor
    },
    computed: {
        avatarSrc() {
            const src = this.src
            if (/^(https:|http:|\/\/)/.test(src)) {
                return src
            } else {
                return this.defaultSrc
            }
        },
        defaultSrc() {
            switch (this.type) {
                case 'C2C':
                    // 个人头像
                    // return 'https://imgcache.qq.com/open/qcloud/video/act/webim-avatar/avatar-2.png'
                    return this.ident === 'a' ? person : actor
                case 'GROUP':
                    // 群默认头像
                    return 'https://imgcache.qq.com/open/qcloud/video/act/webim-avatar/avatar-3.png'
                case this.TIM.TYPES.CONV_SYSTEM:
                    // return systemAvatar
                    return '系统默认头像'
                default:
                    // 默认头像
                    return 'https://imgcache.qq.com/open/qcloud/video/act/webim-avatar/avatar-1.png'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.avatar {
    // background-color: #99a8b4;
    background-color: transparent;
    text-align: center;
    width: 45px;
    height: 45px;
    overflow: hidden;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
.shape-circle {
    border-radius: 5px !important;
}
</style>
